<template>
  <transition name="system-loader-fade">
    <div
      v-if="visible"
      class="system-loader-overlay"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div class="system-loader-panel">
        <span class="system-loader-mark" aria-hidden="true">
          <span class="system-loader-ring"></span>
          <span class="system-loader-pulse"></span>
        </span>
        <span class="system-loader-copy">{{ message }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'GlobalSystemLoader',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: 'Loading...'
    }
  }
};
</script>
